import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'mmb-web-app-user-support-info',
  templateUrl: './user-support-info.component.html',
  styleUrls: ['./user-support-info.component.scss']
})
export class UserSupportInfoComponent implements OnInit {
  @Input() supportItems: any[];

  @Input() helpItems: any[];
  constructor() { }

  ngOnInit() {
  }

}
